import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { OccasionDate } from '@klickdata/core/resource/src/resource.model';
import { Utils } from '@klickdata/core/util';

@Component({
    selector: 'app-menu-side-resource-enrollment-request',
    templateUrl: './menu-side-resource-enrollment-request.component.html',
    styleUrls: ['./menu-side-resource-enrollment-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideResourceEnrollmentRequestComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    Utils = Utils;
    public selectedOccasionId = new FormControl();
    public message = new FormControl();
    SideNaveActionsTypes = SideNaveActionsTypes;
    occasion_dates: OccasionDate[] = [];
    constructor() {}
    ngOnInit() {
        this.occasion_dates = this.getOccasion_dates();
        this.selectFirstValidOccasion();
    }
    getOccasion_dates(): OccasionDate[] {
        const raw = this.navData.data.resource.user_collaboration?.enroll_approval_required?.metadata?.occasion_dates;
        if (!raw?.length) return raw ?? [];
        const notPassed = raw.filter((d) => !d.ispassed);
        const passed = raw.filter((d) => d.ispassed);
        const limitedPassed = passed.slice(0, 2);
        return [...limitedPassed, ...notPassed];
    }
    get availableOccasionsToEnroll() {
        return this.occasion_dates?.filter(
            (date) =>
                Utils.isValidToEnrollOccasionByDate(date) &&
                date.id &&
                !date.ispassed &&
                date.id !== this.navData.data.enrolledOccId
        );
    }

    selectFirstValidOccasion() {
        this.selectedOccasionId.setValue(this.availableOccasionsToEnroll?.[0]?.id);
    }
    onCloseAction(action: any) {
        this.onClose.emit({
            action: SideNaveActionsTypes.POSITIVE,
            data: {
                type: this.navData.data.type,
                response: action.value,
                value: this.message.value,
                selectedOccasionId: this.selectedOccasionId.value,
            },
        });
    }
}
